var LinkShareComponentController = (function () {
    function LinkShareComponentController($location) {
        this.$location = $location;
    }
    LinkShareComponentController.prototype.finishLoading = function () {
        this.contentLoaded = true;
    };
    LinkShareComponentController.$inject = ['$location'];
    return LinkShareComponentController;
}());
export var LinkShareComponent = {
    bindings: {
        contentLoaded: '=',
    },
    controller: LinkShareComponentController,
    template: "<div ng-include=\"'compatibilityguide/ng-templates/feature/forms/linkshare'\" onload=\"$ctrl.finishLoading()\"></div>",
};
